import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, Button, Form, Dropdown } from 'react-bootstrap';
import { FaCheckCircle, FaChevronDown, FaQuestionCircle } from 'react-icons/fa';
import img1 from '../../Pages/Images/basicinfo_img1.webp';
import img2 from '../../Pages/Images/basicinfo_img2.webp';
import img3 from '../../Pages/Images/basicinfo_img3.webp';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from "../../Pages/Navbar/EmployerNavbar";
import './RequiredSkills.css';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import BaseUrl from '../../ApiServices/BaseUrl';

const RequiredSkills = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user?.id;

    const temporaryId = location.state?.temporaryId;
    console.log('receving temporary_id:', temporaryId);

    // Refs for validation focus
    const preferredLanguageRef = useRef(null);
    const mainSkillsRef = useRef(null);
    const cookingSkillsRef = useRef(null);
    const otherSkillsRef = useRef(null);
    const mostImportantSkillsRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [formData, setFormData] = useState({
        preferred_language_for_worker: [],
        main_skills: [],
        cooking_skills: [],
        other_skills: [],
        most_important_skill: [],
        other_language: '',
        other_main_skill: '',
        other_cooking_skill: '',
        other_skill: ''
    });

    // Function to parse the complex skills format from the database
    const parseSkills = (skillsString) => {
        if (!skillsString) return [];

        try {
            const parsed = JSON.parse(skillsString);
            if (typeof parsed === 'string') {
                const secondParse = JSON.parse(parsed);
                if (typeof secondParse === 'string') {
                    return JSON.parse(secondParse);
                }
                return secondParse;
            }
            return parsed;
        } catch (e) {
            console.error('Error parsing skills:', e);
            if (Array.isArray(skillsString)) {
                return skillsString.filter(item => typeof item === 'string' && item.length > 0 && !['"', '[', ']', '\\'].includes(item));
            }
            return [];
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Fetch existing data
    const fetchSavedData = async () => {
        try {
            const response = await fetch(`${BaseUrl}/api/employer?temporary_id=${temporaryId}&user_id=${userId}`);
            if (response.ok) {
                const data = await response.json();

                if (data) {
                    const mainSkills = parseSkills(data.main_skills);
                    const cookingSkills = parseSkills(data.cooking_skills);
                    const otherSkills = parseSkills(data.other_skills);


                    // Parse preferred language - handle both string and array
                    let preferredLanguages = [];
                    if (data.preferred_language_for_worker) {
                        try {
                            // Try to parse as JSON first
                            const parsed = JSON.parse(data.preferred_language_for_worker);
                            if (Array.isArray(parsed)) {
                                preferredLanguages = parsed.filter(lang => lang && lang.trim());
                            } else if (typeof parsed === 'string') {
                                preferredLanguages = [parsed];
                            }
                        } catch {
                            // If it's a simple string, convert to array
                            if (data.preferred_language_for_worker) {
                                preferredLanguages = [data.preferred_language_for_worker];
                            }
                        }
                    }

                    let importantSkills = [];
                    if (data.most_important_skill) {
                        importantSkills = data.most_important_skill.split(',').map(s => s.trim());
                    }

                    setFormData({
                        preferred_language_for_worker: preferredLanguages,
                        main_skills: mainSkills,
                        cooking_skills: cookingSkills,
                        other_skills: otherSkills,
                        most_important_skill: importantSkills,
                        other_language: '',
                        other_main_skill: '',
                        other_cooking_skill: '',
                        other_skill: ''
                    });
                    setIsSaved(true);
                }
            } else {
                console.error('Failed to fetch data:', response.status);
            }
        } catch (error) {
            console.error('Error fetching employer data:', error);
            Swal.fire('Error', 'Failed to fetch employer data', 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userId) {
            fetchSavedData();
        }
    }, [userId, temporaryId]);

    // Focus function for validation errors
    // const focusOnField = (fieldName) => {
    //     setTimeout(() => {
    //         let element = null;

    //         switch (fieldName) {
    //             case 'preferred_language_for_worker':
    //                 element = preferredLanguageRef.current;
    //                 break;
    //             case 'main_skills':
    //                 element = mainSkillsRef.current;
    //                 break;
    //             case 'cooking_skills':
    //                 element = cookingSkillsRef.current;
    //                 break;
    //             case 'other_skills':
    //                 element = otherSkillsRef.current;
    //                 break;
    //             case 'most_important_skill':
    //                 element = mostImportantSkillsRef.current;
    //                 break;
    //             default:
    //                 break;
    //         }

    //         if (element) {
    //             element.scrollIntoView({ behavior: 'smooth', block: 'center' });

    //             setTimeout(() => {
    //                 if (element.focus) {
    //                     element.focus();
    //                     if (document.activeElement !== element) {
    //                         element.focus();
    //                     }
    //                 }
    //             }, 300);
    //         }
    //     }, 100);
    // };

    // Validation function
    // const validateFormData = async () => {
    //     const requiredFields = [
    //         { field: 'preferred_language_for_worker', name: 'Preferred Language' },
    //         { field: 'main_skills', name: 'Main Skills' },
    //         { field: 'cooking_skills', name: 'Cooking Skills' },
    //         { field: 'most_important_skill', name: 'Most Important Skills' }
    //     ];

    //     const missingFields = requiredFields.filter(item => {
    //         if (item.field === 'preferred_language_for_worker') {
    //             return !formData[item.field] && !formData.other_language;
    //         }
    //         return !formData[item.field] || formData[item.field].length === 0;
    //     });

    //     if (missingFields.length > 0) {
    //         const result = await Swal.fire({
    //             title: 'Error!',
    //             text: `Please fill in all required fields: ${missingFields.map(item => item.name).join(', ')}`,
    //             icon: 'error',
    //             confirmButtonText: 'OK',
    //             confirmButtonColor: '#d33',
    //         });

    //         if (result.isConfirmed || result.isDismissed) {
    //             const firstMissingField = missingFields[0];
    //             focusOnField(firstMissingField.field);
    //         }
    //         return false;
    //     }

    //     // Validate most important skills count (1-3)
    //     if (formData.most_important_skill.length === 0 || formData.most_important_skill.length > 3) {
    //         const result = await Swal.fire({
    //             title: 'Error!',
    //             text: 'Please select 1 to 3 most important skills',
    //             icon: 'error',
    //             confirmButtonText: 'OK',
    //             confirmButtonColor: '#d33',
    //         });

    //         if (result.isConfirmed || result.isDismissed) {
    //             focusOnField('most_important_skill');
    //         }
    //         return false;
    //     }

    //     // Validate cooking skills count (1-4)
    //     if (formData.cooking_skills.length === 0) {
    //         const result = await Swal.fire({
    //             title: 'Error!',
    //             text: 'Please select at least 1 cooking skill',
    //             icon: 'error',
    //             confirmButtonText: 'OK',
    //             confirmButtonColor: '#d33',
    //         });

    //         if (result.isConfirmed || result.isDismissed) {
    //             focusOnField('cooking_skills');
    //         }
    //         return false;
    //     }

    //     return true;
    // };

    // Save data function
    const saveData = async () => {
        setIsLoading(true);

        Swal.fire({
            title: 'Saving...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Combine cooking skills with other cooking skill if it exists
            const allCookingSkills = [...formData.cooking_skills];
            if (formData.other_cooking_skill) {
                allCookingSkills.push(formData.other_cooking_skill);
            }

            // Combine languages with other language if it exists
            const allLanguages = [...formData.preferred_language_for_worker];
            if (formData.other_language) {
                allLanguages.push(formData.other_language);
            }

            const payload = {
                temporary_id: temporaryId,
                user_id: userId,
                preferred_language_for_worker: JSON.stringify(allLanguages.filter(Boolean)),
                main_skills: JSON.stringify([...formData.main_skills, formData.other_main_skill].filter(Boolean)),
                cooking_skills: JSON.stringify(allCookingSkills.filter(Boolean)),
                other_skills: JSON.stringify([...formData.other_skills, formData.other_skill].filter(Boolean)),
                most_important_skill: formData.most_important_skill.join(', ')
            };

            const response = await fetch(`${BaseUrl}/api/employer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to save data');
            }

            await Swal.fire({
                title: 'Success!',
                text: 'Your skills and qualifications have been saved successfully.',
                icon: 'success',
                confirmButtonText: 'OK',
                confirmButtonColor: '#3085d6',
            });

            setIsSaved(true);
            return data;
        } catch (err) {
            console.error('Error saving data:', err);

            await Swal.fire({
                title: 'Error!',
                text: err.message || 'Failed to save data. Please try again.',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#d33',
            });

            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    const handleSave = async () => {
        // const isValid = await validateFormData();
        // if (!isValid) return;

        try {
            await saveData();
        } catch (err) {
            // Error already handled in saveData
        }
    };

    const handleNext = async () => {
        // const isValid = await validateFormData();
        // if (!isValid) return;

        try {
            await saveData();
            window.scrollTo(0, 0);
            navigate('/candidatepreference', { state: { userId, temporaryId } });
        } catch (err) {
            // Error already handled in saveData
        }
    };

    // Custom Dropdown Component with Search
    const CustomDropdown = ({
        title,
        field,
        options,
        selectedValue,
        onSelect,
        disabled = false
    }) => {
        const [localSearchTerm, setLocalSearchTerm] = useState('');
        const [isOpen, setIsOpen] = useState(false);

        const filterOptions = (options, searchTerm) => {
            if (!searchTerm) return options;
            return options.filter(option =>
                option.toString().toLowerCase().includes(searchTerm.toLowerCase())
            );
        };

        const filteredOptions = filterOptions(options, localSearchTerm);

        return (
            <Dropdown
                className="mb-3 custom-searchable-dropdown" // Added unique classname
                show={isOpen}
                onToggle={(isOpen) => setIsOpen(isOpen)}
            >
                <Dropdown.Toggle
                    variant="light"
                    className="custom-searchable-dropdown-toggle dropdown-btn w-100 d-flex justify-content-between align-items-center" // Added unique classname
                    id={`dropdown-${field}`}
                    disabled={disabled}
                >
                    {selectedValue || title}
                </Dropdown.Toggle>
                <Dropdown.Menu className="custom-searchable-dropdown-menu w-100" style={{ overflowY: 'hidden' }}> {/* Added unique classname */}
                    <div className="px-2 py-1 custom-searchable-dropdown-search"> {/* Added unique classname */}
                        <Form.Control
                            type="text"
                            placeholder={`Search ${title.toLowerCase()}...`}
                            value={localSearchTerm}
                            onChange={(e) => setLocalSearchTerm(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            className="mb-2 custom-searchable-dropdown-input" // Added unique classname
                            autoFocus
                        />
                    </div>
                    <div className="custom-searchable-dropdown-options" style={{ maxHeight: '250px', overflowY: 'auto' }}> {/* Added unique classname */}
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((option) => (
                                <Dropdown.Item
                                    key={option}
                                    active={selectedValue === option}
                                    onClick={() => {
                                        onSelect(field, option);
                                        setLocalSearchTerm('');
                                        setIsOpen(false);
                                    }}
                                    className="custom-searchable-dropdown-item" // Added unique classname
                                >
                                    {option}
                                </Dropdown.Item>
                            ))
                        ) : (
                            <Dropdown.Item disabled className="custom-searchable-dropdown-no-match"> {/* Added unique classname */}
                                No matches found
                            </Dropdown.Item>
                        )}
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    const handleSkillSelect = (category, skill) => {
        setFormData(prev => {
            if (category === 'most_important_skill') {
                const alreadySelected = prev[category].includes(skill);
                if (alreadySelected) {
                    return {
                        ...prev,
                        [category]: prev[category].filter(s => s !== skill)
                    };
                } else if (prev[category].length < 3) {
                    return {
                        ...prev,
                        [category]: [...prev[category], skill]
                    };
                }
                return prev;
            }

            // For preferred_language_for_worker - allow multiple selections with no limit
            if (category === 'preferred_language_for_worker') {
                const alreadySelected = prev[category].includes(skill);
                if (alreadySelected) {
                    return {
                        ...prev,
                        [category]: prev[category].filter(l => l !== skill)
                    };
                } else {
                    return {
                        ...prev,
                        [category]: [...prev[category], skill]
                    };
                }
            }

            // For cooking_skills, limit to maximum 4 items
            if (category === 'cooking_skills') {
                const alreadySelected = prev[category].includes(skill);
                if (alreadySelected) {
                    return {
                        ...prev,
                        [category]: prev[category].filter(s => s !== skill)
                    };
                } else if (prev[category].length < 4) {
                    return {
                        ...prev,
                        [category]: [...prev[category], skill]
                    };
                } else {
                    // Show warning when trying to select more than 4
                    Swal.fire({
                        icon: 'warning',
                        title: 'Maximum Limit Reached',
                        text: 'You can select only up to 4 cooking skills. Please deselect one to select another.',
                        confirmButtonColor: '#0d47a1'
                    });
                    return prev;
                }
            }

            // For other categories, no limit
            if (prev[category].includes(skill)) {
                return {
                    ...prev,
                    [category]: prev[category].filter(s => s !== skill)
                };
            } else {
                return {
                    ...prev,
                    [category]: [...prev[category], skill]
                };
            }
        });
        setIsSaved(false);
    };

    const handleOtherSelect = (field, value) => {
        setFormData(prev => {
            // For other_cooking_skill, check if we're already at the limit
            if (field === 'other_cooking_skill' && value && prev.cooking_skills.length >= 4) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Maximum Limit Reached',
                    text: 'You can select only up to 4 cooking skills. Please deselect one to add another.',
                    confirmButtonColor: '#0d47a1'
                });
                return prev;
            }

            return {
                ...prev,
                [field]: value
            };
        });
        setIsSaved(false);
    };

    const isSkillSelected = (category, skill) => {
        return formData[category].includes(skill);
    };

    const selectedButtonStyle = {
        backgroundColor: '#0d47a1',
        color: 'white',
        borderColor: '#0d47a1'
    };

    // Dropdown options
    const languages = [
        "English", "Arabic", "Phillipin", "Indonesia"
    ];

    const otherLanguageOptions = [
        "Tamil", "Malayalam", "Nepali", "Srilankan", "Hindi",
        "Japanese", "Russian", "Bangali", "Cantonese", "Vietnamese", "Mandarin",
        "Combodian", "Iranian", "Thai", "Macanese", "Punjabi", "Portuguese", "German", "Spanish", "Polish", "Ukrainian",
        "Hebrew", "Persian", "Urdu", "Sinhalese", "Korean"
    ];

    const mainSkills = [
        "Baby care", "Child care", "Teen care", "Elderly care",

    ];

    const otherMainSkillOptions = [
        "CNC Machinist",

        "CNC Milling Programmer",
        "CNC Turning Programmer",
        "CNC 5-Axis Programmer",
        "CNC CAD/CAM Programmer",
        "CNC Setter",
        "CNC Setup Operator",
        "CNC Quality Inspector (CMM)",
        "CNC Maintenance Technician",
        "CNC Tool Room Technician",
        "CNC Production Technician",
        "CNC Machine Operator",
        "CNC Milling Operator",
        "CNC Turning Operator",
        "CNC Lathe Operator",
        "CNC VMC Operator",
        "CNC HMC Operator",
        "Home Driver",
        "Home Cook",
        "Home Care Nurse",
        "Home Caregiver", "Pets care", "Tutoring", "Housekeeping", "Cooking", "Marketing", "Groceries", "Organization", "Event planning", "Special needs care", "Newborn care", "Postpartum care",
        "Household management", "Meal planning", "Errands running", "Laundry services",
        // New options from your list (duplicates removed)

        "Company Driver",
        "Light Driver",
        "Motorbike Driver",
        "Domestic Helper",
        "Maid",
        "Driver",
        "Driver (Company / House)",
        "Lady Driver",
        "Personal Driver",
        "Bus Driver",
        "Plumber",
        "Taxi Driver",
        "Operator",
        "Electrician",
        "Welder",
        "Fabricator",
        "Pipe Fitter",
        "Cook",
        "Cook (Company / House)",
        "Nanny",
        "Nurse",
        "Rehabilitation Therapy",
        "Pain Management",
        "Manual Therapy",
        "Electrotherapy",
        "Exercise Therapy",
        "Post-Surgery Rehab",
        "ICU Rehab",
        "Houseboy",
        "Tailor",
        "Teacher",
        "Trainer",
        "Beautician",
        "Gardener",
        "Farmar",
        "Butler",
        "Housekeeper",
        "Laundry Worker",
        "Personal Assistant",
        "Caregiver",
        "Elder Care",
        "Pet Sitter",
        "House Manager",
        "Cleaner",
        "Maintenance Worker",
        "Baby Sitter",
        "Tutor",
        "Chauffeur",
        "Housemaid",
        "Kitchen Staff",
        "Dining Room Attendant",
        "Personal Chef",
        "Event Coordinator",
        "Household Administrator",
        "Domestic Assistant",
        "Hospital Nurse",
        "Physiotherapy",
        "Hospital Doctor",
        "Resident Doctor",
        "Heavy Driver",
        "Bike Driver",
        "JCB Operator",
        "Bulldozer Operator",
        "Excavator Operator",
        "Loader Operator",
        "Skid Steer Loader Operator",
        "Grader Operator",
        "Trench Excavator / Trencher Operator",
        "Backhoe Operator",
        "Dragline Operator",
        "Scraper Operator",
        "Crane Operator",
        "Telehandler Operator",
        "Reach Stacker Operator",
        "Boom Lift / Cherry Picker Operator",
        "Container Handler Operator",
        "Road Roller Operator",
        "Asphalt Paver Operator",
        "Bitumen Sprayer Operator",
        "Concrete Paver Operator",
        "Soil Stabilizer Operator",
        "Drilling Machine / Drill Rig Operator",
        "Rock Breaker / Hydraulic Hammer Operator",
        "Loader-Dumper Operator",
        "Dump Truck Operator",
        "Stone Crusher Operator",
        "Grizzly Feeder / Conveyor Operator",
        "Tractor Operator",
        "Harvester / Combine Operator",
        "Dozer / Land Leveling Operator",
        "Tower Crane Operator",
        "Mobile Crane Operator",
        "Crawler Crane Operator",
        "Piling Machine Operator",
        "Concrete Mixer Truck Operator",
        "Concrete Pump Operator",
        "Compactor Operator",
        "Pipe Layer Operator",
        "Forklift / Warehouse Equipment Operator",
        "Boom Truck / Loader Crane Operator",
        "Road Sweeper Operator",
        "Water Tanker / Firefighting Vehicle Operator",
        "Excavator Mounted Drill Operator",
        "Heavy Truck / Tip Truck Operator",
        "Loader Excavator Operator",
        "Teleporter Crane Operator",
        "Material Handler / Port Crane Operator",
        "Hydraulic Excavator Operator",
        "Multi-Functional Heavy M",
        "Workers",
        "Skilled Workers",
        "Construction Workers",
        "Skilled Construction Workers",
        "Mason",
        "Carpenter",
        "Steel Fixer",
        "Painter",
        "AC Technician", "HVAC Technician", "Chiller Technician",
        "Lathe & Milling Machine", "Lathe Machine Operator", "Milling Machine Operator",
        "Heavy Equipment Operator",
        "Scaffolder",
        "Healthcare Assistants",
        "Doctors",
        "Lab Technicians",
        "Physiotherapy",
        "Physiotherapists",
        "Elderly Care Workers",
        "Hospitality Workers",
        "Hotel Staff",
        "Waiters",
        "Waitresses",
        "Chefs",
        "Kitchen Helpers",
        "Baristas",
        "Factory Workers",
        "Production Workers",
        "Warehouse Workers",
        "Packing Staff",
        "Machine Operators",
        "Assembly Line Workers",
        "Forklift Operators",
        "Delivery Drivers",
        "Truck Drivers",
        "Logistics Staff",
        "Farm Workers",
        "Fruit Pickers",
        "Dairy Workers",
        "Poultry Workers",
        "Greenhouse Workers",
        "Caretakers",
        "Private Drivers"
    ];
    const cookingSkills = [
        "Arabic", "Indian", "Italian", "Japanese",
    ];

    const otherCookingSkillOptions = [
        "Chinese", "Thai", "Singaporean",
        "Vegetarian", "Western", "French", "Mexican", "Turkey", "Moroccan",
        "Brazilian", "Labanese", "Spain", "Greece", "United States", "Vegan", "Paleo", "Peruvian", "Indonesian", "African", "Caribbean",
        "Fusion", "Mediterranean", "Vegan", "Paleo", "Keto",
        "Halal", "Kosher", "Gluten-free"
    ];

    const otherSkills = [
        "Baking", "Caregiver", "Car wash", "Computer",
    ];

    const otherSkillOptions = [
        "Driving Lic.", "Firstaid",
        "Gardening", "Handiman", "Housework", "Sewing", "Swimming", "Cleaning", "Massage therapy", "Yoga instruction", "Pet grooming",
        "House sitting", "Plant care", "Computer repair",
        "Art instruction", "Music lessons", "Language tutoring"
    ];

    const importantSkills = [
        "Nanny", "Housemaid", "Caregiver", "Housekeeper"
    ];

    const otherImportantSkillsOptions = [
        "Babysitter", "House Nurse", "Home Nurse", "Home Tutor", "House Teacher",
        "Cook", "Cleaner", "Laundress", "Ironer", "Gardener", "Driver", "Butler",
        "Elder-caregiver", "Child-caregiver", "Pet Sitter", "Care Assistant",
        "Personal Attendant", "Domestic Helper"
    ];

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <Navbar />
            <Container fluid className="job-form py-4" style={{ marginTop: '70px' }}>
                <div className="form-header text-center">
                    <h1 className="req-skills-heading d-flex align-items-center justify-content-center">
                        <i className="bi bi-person-vcard me-2" style={{ fontSize: '60px' }}></i>
                        Required skills and qualifications
                    </h1>
                </div>


                {/* Preferred Language Section */}
                <div className="section mt-3" ref={preferredLanguageRef}>
                    <h5 className="d-flex align-items-center req-skills-preferred">
                        <span style={{ color: 'black' }}>Your preferred language</span>
                        <span className="ms-2 text-muted language-hint">
                            (Select one or more languages)
                        </span>
                    </h5>

                    {/* Selection Counter */}
                    <div className="">
                        {/* <span className="text-info">
                                Selected: {formData.preferred_language_for_worker.length}
                            </span> */}
                    </div>

                    {/* Show only first 4 buttons */}
                    {/* Show only first 4 buttons - allow multiple selection */}
                    <Row className="g-3 mb-3">
                        {languages.map((type, idx) => (
                            <Col xs={6} md={3} key={idx}>
                                <Button
                                    className={`language-btn w-100 ${isSkillSelected('preferred_language_for_worker', type) ? 'selected-button' : ''}`}
                                    onClick={() => handleSkillSelect('preferred_language_for_worker', type)}
                                >
                                    {type}
                                    {isSkillSelected('preferred_language_for_worker', type) && (
                                        <span className="ms-2">✓</span>
                                    )}
                                </Button>
                            </Col>
                        ))}
                    </Row>


                    {/* Single dropdown containing ALL other languages */}

                    <div className="mb-3">
                        <CustomDropdown
                            title="Other Languages Select Here"
                            field="other_language"
                            options={otherLanguageOptions}
                            selectedValue={formData.other_language}
                            onSelect={(field, value) => {
                                // Clear the dropdown selection first
                                handleOtherSelect(field, "");

                                // Add the selected language to the preferred languages array
                                setFormData(prev => {
                                    const alreadySelected = prev.preferred_language_for_worker.includes(value);
                                    if (alreadySelected) {
                                        return prev;
                                    }
                                    return {
                                        ...prev,
                                        preferred_language_for_worker: [...prev.preferred_language_for_worker, value]
                                    };
                                });
                                setIsSaved(false);
                            }}
                        />
                        {/* <div className="mt-2">
                                <small className="text-muted">Selecting from this dropdown will add the language to your preferred languages</small>
                            </div> */}
                    </div>

                    {/* Display selected languages */}
                    {formData.preferred_language_for_worker.length > 0 && (
                        <div className="mt-3 p-3 border rounded bg-light">
                            <h6 className="mb-2">Selected Languages:</h6>
                            <div className="d-flex flex-wrap gap-2">
                                {formData.preferred_language_for_worker.map((lang, index) => (
                                    <span key={index} className="badge bg-primary d-flex align-items-center">
                                        {lang}
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white ms-2"
                                            style={{ fontSize: '0.5rem' }}
                                            onClick={() => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    preferred_language_for_worker: prev.preferred_language_for_worker.filter((_, i) => i !== index)
                                                }));
                                                setIsSaved(false);
                                            }}
                                            aria-label="Remove"
                                        ></button>
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}

                </div>


                {/* Main Skills Section */}
                <div className="section mt-3" ref={mainSkillsRef}>
                    <h5 className="d-flex align-items-center req-skills-preferred">
                        <span style={{ color: 'black' }}>Main Skills</span>
                    </h5>
                    <Row className="g-3 mb-3">
                        {mainSkills.map((skill, idx) => (
                            <Col xs={6} md={3} key={idx}>
                                <Button
                                    className={`language-btn w-100 ${isSkillSelected('main_skills', skill) ? 'selected-button' : ''}`}
                                    onClick={() => handleSkillSelect('main_skills', skill)}
                                >
                                    {skill}
                                </Button>
                            </Col>
                        ))}
                    </Row>
                    <CustomDropdown
                        title="Other Main Skill Select here"
                        field="other_main_skill"
                        options={otherMainSkillOptions}
                        selectedValue={formData.other_main_skill}
                        onSelect={(field, value) => handleOtherSelect(field, value)}
                    />
                </div>

                {/* Cooking Skills Section */}
                <div className="section mt-3" ref={cookingSkillsRef}>
                    <h5 className="d-flex align-items-center req-skills-preferred">
                        <span style={{ color: 'black', marginBottom: '-15px' }}>
                            Cooking Skills
                            <span className="ms-2 text-muted" style={{ fontSize: '16px' }}>
                                (Select up to 4 skills)
                            </span>
                        </span>
                    </h5>

                    {/* Selection Counter */}
                    <div className="">
                        {/* <span className="text-info">
                            Selected: {formData.cooking_skills.length}/4
                        </span> */}
                    </div>

                    <Row className="g-3 mb-3 mt-3">
                        {cookingSkills.map((skill, idx) => (
                            <Col xs={6} md={3} key={idx}>
                                <Button
                                    className={`language-btn w-100 ${isSkillSelected('cooking_skills', skill) ? 'selected-button' : ''}`}
                                    onClick={() => handleSkillSelect('cooking_skills', skill)}
                                    disabled={formData.cooking_skills.length >= 4 && !isSkillSelected('cooking_skills', skill)}
                                >
                                    {skill}
                                    {isSkillSelected('cooking_skills', skill) && (
                                        <span className="ms-2">✓</span>
                                    )}
                                </Button>
                            </Col>
                        ))}
                    </Row>
                    <CustomDropdown
                        title="Other Cooking Skill Select here"
                        field="other_cooking_skill"
                        options={otherCookingSkillOptions}
                        selectedValue={formData.other_cooking_skill}
                        onSelect={(field, value) => handleOtherSelect(field, value)}
                        disabled={formData.cooking_skills.length >= 4}
                    />
                    {formData.cooking_skills.length >= 4 && (
                        <div className="text-warning mt-2">
                            <small>Maximum 4 cooking skills reached. Please deselect one to add another.</small>
                        </div>
                    )}
                </div>

                {/* Other Skills Section */}
                <div className="section mt-3" ref={otherSkillsRef}>
                    <h5 className="d-flex align-items-center req-skills-preferred">
                        <span style={{ color: 'black' }}>Other Skills</span>
                    </h5>
                    <Row className="g-3 ">
                        {otherSkills.map((skill, idx) => (
                            <Col xs={6} md={3} key={idx}>
                                <Button
                                    className={`language-btn w-100 ${isSkillSelected('other_skills', skill) ? 'selected-button' : ''}`}
                                    onClick={() => handleSkillSelect('other_skills', skill)}
                                >
                                    {skill}
                                </Button>
                            </Col>
                        ))}
                    </Row>
                    <CustomDropdown
                        title="Other Skill Select here"
                        field="other_skill"
                        options={otherSkillOptions}
                        selectedValue={formData.other_skill}
                        onSelect={(field, value) => handleOtherSelect(field, value)}
                    />
                </div>

                {/* Most Important Skills Section */}
                {/* Most Important Skills Section */}
                <div className="section mt-3" ref={mostImportantSkillsRef}>
                    <h5 className="d-flex align-items-center req-skills-preferred">
                        <span style={{ color: 'black', marginBottom: '-15px' }}>
                            Most Important Skills
                            <span className="ms-2 text-muted" style={{ fontSize: '13px' }}>
                                (Select 1 to 3 most important skills)
                            </span>
                        </span>
                    </h5>

                    {/* Selection Counter */}
                    <div className="mb-1">
                        {/* <span className="text-info">
            Selected: {formData.most_important_skill.length}/3
        </span> */}
                    </div>

                    {/* First row - show 4 buttons */}
                    <Row className="g-3 mb-3 mt-3">
                        {importantSkills.map((skill, idx) => (
                            <Col xs={6} md={3} key={idx}>
                                <Button
                                    className={`language-btn w-100 ${isSkillSelected('most_important_skill', skill) ? 'selected-button' : ''}`}
                                    onClick={() => handleSkillSelect('most_important_skill', skill)}
                                    disabled={formData.most_important_skill.length >= 3 && !isSkillSelected('most_important_skill', skill)}
                                >
                                    {skill}
                                    {isSkillSelected('most_important_skill', skill) && (
                                        <span className="ms-2">✓</span>
                                    )}
                                </Button>
                            </Col>
                        ))}
                    </Row>

                    {/* Dropdown for remaining important skills */}
                    <div className="mb-3">
                        <CustomDropdown
                            title="Other Important Skills Select Here"
                            field="most_important_skill_dropdown"
                            options={otherImportantSkillsOptions}
                            selectedValue=""
                            onSelect={(field, value) => {
                                // Add the selected skill to most_important_skill array
                                setFormData(prev => {
                                    // Check if we're at the limit
                                    if (prev.most_important_skill.length >= 3) {
                                        Swal.fire({
                                            icon: 'warning',
                                            title: 'Maximum Limit Reached',
                                            text: 'You can select only up to 3 most important skills. Please deselect one to select another.',
                                            confirmButtonColor: '#0d47a1'
                                        });
                                        return prev;
                                    }

                                    // Check if already selected
                                    const alreadySelected = prev.most_important_skill.includes(value);
                                    if (alreadySelected) {
                                        return prev;
                                    }

                                    // Add the skill
                                    return {
                                        ...prev,
                                        most_important_skill: [...prev.most_important_skill, value]
                                    };
                                });
                                setIsSaved(false);
                            }}
                        />
                    </div>
                </div>

                {/* Navigation Buttons */}
                <div className="additional-section mb-4" style={{ marginTop: '40px' }}>
                    <div
                        className="d-flex justify-content-between gap-2"
                        style={{ width: "100%" }}
                    >
                        <Button
                            className="nav-btn"
                            style={{ flex: 1 }}
                            variant="secondary"
                            onClick={() => navigate('/basicinfo', { state: { userId, temporaryId } })}
                        >
                            Back
                        </Button>

                        <Button
                            className="nav-btn"
                            style={{ flex: 1 }}
                            variant=""
                            onClick={handleNext}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Saving...' : 'Next'}
                        </Button>
                    </div>
                </div>
            </Container>
        </>
    );
};

export default RequiredSkills;
